const Component = () => {
  return <>PAGE 404</>
}

export default Component
